import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from 'recharts';
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from '@/components/ui/chart';
import { ChartCard } from '@/components/dashboard/ChartCard';
import { MONTH_LABELS, formatAxis, plnTooltipFormatter } from '@/components/dashboard/chart-utils';
import { t } from '@/i18n';
import type { SalesSummaryMonth } from '@ip/shared-types';

interface SalesMonthlyChartProps {
  months: SalesSummaryMonth[];
  year: number;
}

export function SalesMonthlyChart({ months, year }: SalesMonthlyChartProps) {
  const chartData = MONTH_LABELS.map((label, i) => {
    const found = months.find((m) => m.month === i + 1);
    return {
      month: label,
      net: found?.net ?? 0,
    };
  });

  const config: ChartConfig = {
    net: { label: t('sales.netAmount'), color: 'var(--chart-1)' },
  };

  return (
    <ChartCard title={t('sales.monthlyRevenue')}>
      <ChartContainer config={config} className="h-[300px] w-full">
        <BarChart data={chartData}>
          <CartesianGrid vertical={false} strokeOpacity={0.4} />
          <XAxis dataKey="month" tickLine={false} axisLine={false} />
          <YAxis tickFormatter={formatAxis} tickLine={false} axisLine={false} width={64} />
          <ChartTooltip
            content={
              <ChartTooltipContent
                labelFormatter={(label) => `${label} ${year}`}
                formatter={plnTooltipFormatter(config)}
              />
            }
          />
          <Bar dataKey="net" fill="var(--color-net)" radius={[4, 4, 0, 0]} maxBarSize={28} />
        </BarChart>
      </ChartContainer>
    </ChartCard>
  );
}
